<div class="container">
    <h2 style="display:flex; justify-content:flex-start; align-items:center">
        <vng-icon name="keyboard_arrow_left" [outline]="false" (click)="nav.back()" style="cursor:pointer; margin-right: 10px; display: inline;"></vng-icon>
        <span style="font-weight: 700; font-size: 16px;">Add Payment Method</span>
    </h2>

    <vng-card variant="outline" title="Card Information">
        <vng-divider></vng-divider>
        <div class="credit-card-info" style="display:flex; flex-direction:column">
            <vng-input label="Name on Card" placeholder="Name on Card" [(ngModel)]="name" name="name"></vng-input>
            <!-- Stripe Elements Placeholder -->
            <div class="my-input" #paymentElement></div>
        </div>
        <div vngCardFooter style="display:flex; justify-content:center; align-items:center">
            <button (click)="addPaymentMethod()" vng-button variant="primary" class="add-payment-button">
                Add Payment Method
            </button>
        </div>
    </vng-card>
</div>
